import {Suspense} from 'react'

import {noop} from '@sdox/utils'

import {Loading} from './Loading'

import type {PropsWithChildren, SuspenseProps} from 'react'

export interface WithSuspenseProps extends PropsWithChildren {
  varHook?: () => void
  fallback?: SuspenseProps['fallback']
}

export  const WithSuspense = ({
  varHook = noop,
  fallback = <Loading />,
  children,
}: WithSuspenseProps) => {
  varHook()

  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  )
}